export const WORKSPACE_ROLES_EVENT_VERSION = 2 as const;
